'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cartProduct = cartProduct;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*@ngInject*/
function cartProduct() {
    var clazz = function CartProduct() {
        var defaults = {
            id: 0,
            amount: 0,
            productNumber: '',
            discountAmount: 0,
            discountId: 0,
            discountPercentage: 0,
            discountPromoCode: null,
            discountValueTypeSymbol: null,
            grossProfit: 0,
            totalPriceDiscountId: 0,
            grossProfitAmount: 0,
            cartProduct: []
        };

        _lodash2.default.extend(this, defaults);
    };

    _lodash2.default.extend(clazz.prototype, {

        getCartFields: function getCartFields(product, cartProducts) {
            var this_ = this;

            //find the product in the shoppingcart
            var productSearch = cartProducts.find(function (x) {
                if (this_.nationalNumber) {
                    return x.productNumber === this_.nationalNumber;
                } else {
                    return x.id === this_.id;
                }
            });

            //set the fields from the value from the products that are already in the cart
            if (productSearch) {
                product.discountPct = productSearch.discountPercentage;
                product.promocode = productSearch.discountPromoCode;
                product.totalDiscount = productSearch.discountAmount;
                product.quantity = productSearch.amount;

                productSearch.productWithPossibleDiscounts.map(function (discount) {
                    product.activeDiscountIds.push(discount.discountIds);
                    product.totalPriceDiscountIds.push(discount.totalPriceDiscountId);
                });
            }
            return product;
        }

    });

    clazz.create = function (resource) {
        var cartProduct = new clazz();
        cartProduct.id = resource.id;
        cartProduct.amount = resource.amount;
        cartProduct.productNumber = resource.productNumber;
        cartProduct.discountAmount = resource.discountAmount;
        cartProduct.discountId = resource.discountId;
        cartProduct.discountPercentage = resource.discountPercentage;
        cartProduct.discountPromoCode = resource.discountPromoCode;
        cartProduct.discountValueTypeSymbol = resource.discountValueTypeSymbol;
        cartProduct.grossProfit = resource.grossProfit;
        cartProduct.totalPriceDiscountId = resource.totalPriceDiscountId;
        cartProduct.totalPriceDiscountPromoCode = resource.totalPriceDiscountPromoCode;
        cartProduct.grossProfitAmount = resource.grossProfitAmount;
        cartProduct.productWithPossibleDiscounts = resource.productWithPossibleDiscounts;

        resource.productWithPossibleDiscounts;

        return cartProduct;
    };

    return clazz;
}


//////////////////
// WEBPACK FOOTER
// ./common/models/cartProduct.js
// module id = 734
// module chunks = 0